import React, { Component } from 'react';
import { Row, Column } from 'simple-flexbox';
import { Panel, Button } from "react-bootstrap";
import SweetAlert from 'sweetalert2-react';

import ComponentHeader from "../../componentHeader";
import Form from "../../../core/Form";
import Select from "../Select";
import Spinner from '../../Spinner';

import "../../../assets/css/generateReports.css";
import "../../../assets/css/requestPayout.css";
import PayoutIcon from '../../../assets/images/report.png';

import { crudActions } from "../../../services/crudActions";

class RequestPayout extends Component {
  state = {
    payoutForm: new Form({
      mid: "",
      currency: "",
      orderId: this.generateUUID(),
      country: "",
      account: "",
      ipaddress: "",
      email: "",
      amount: "",
      payoutCurrency: "",
      callbackUrl: "",
      returnUrl: "",
      accountNumber: "",
      bankName: "",
      bankBranch: ""
    }, [{
      name: "mid",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "currency",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "orderId",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "country",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "account",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "ipaddress",
      type: "isPattern",
      rules: {
        required: true,
        pattern: "^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^::1$|^::$|^(?:[0-9a-fA-F]{1,4}:){1,7}:$|^:(?::[0-9a-fA-F]{1,4}){1,7}$|^(?:[0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}$|^(?:[0-9a-fA-F]{1,4}:){1,5}(?::[0-9a-fA-F]{1,4}){1,2}$|^(?:[0-9a-fA-F]{1,4}:){1,4}(?::[0-9a-fA-F]{1,4}){1,3}$|^(?:[0-9a-fA-F]{1,4}:){1,3}(?::[0-9a-fA-F]{1,4}){1,4}$|^(?:[0-9a-fA-F]{1,4}:){1,2}(?::[0-9a-fA-F]{1,4}){1,5}$|^[0-9a-fA-F]{1,4}:(?::[0-9a-fA-F]{1,4}){1,6}$",
        customErrorMessage: "Please enter a valid IPv4 or IPv6 address"
      }
    }, {
      name: "email",
      type: "isEmail",
      rules: {
        required: true
      }
    }, {
      name: "amount",
      type: "isNumber",
      rules: {
        required: true,
        min: 0.01
      }
    }, {
      name: "payoutCurrency",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "callbackUrl",
      type: "isUrl",
      rules: {
        required: true
      }
    }, {
      name: "returnUrl",
      type: "isUrl",
      rules: {
        required: true
      }
    }, {
      name: "accountNumber",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "bankName",
      type: "isString",
      rules: {
        required: true
      }
    }, {
      name: "bankBranch",
      type: "isString",
      rules: {
        required: true
      }
    }]),

    mids: [],
    currencies: [],
    countries: [],
    availableBalance: null,
    showBalance: false,

    dynamicFields: [],
    isLoadingParams: false,
    useDefaultFields: true,

    isLoading: false,
    isLoadingBalance: false,
    showSuccess: false,
    showError: false,
    errorMessage: "",
    successMessage: "",
    submitClicked: false
  };

  componentDidMount() {
    this.loadInitialData();
  }

  generateUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    // Fallback for older browsers
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  loadInitialData = () => {
    // Load MIDs and currencies from API
    crudActions.get(`v1/payout/mids`).then(
      (data) => {
        if (data) {
          this.setState({
            mids: data,
            currencies: [

            ]
          });
        }
      }
    ).catch((err) => {
      // Fallback empty data
      this.setState({
        mids: []
      });
    });

    // Load countries from API
    crudActions.get(`v1/reports/lookups`).then(
      (data) => {
        if (data && data.countries) {
          this.setState({
            countries: data.countries
          });
        }
      }
    ).catch((err) => {
      // Fallback empty countries
      this.setState({
        countries: []
      });
    });
  };

  onValueChange = (value, fieldName) => {
    let { payoutForm } = this.state;
    const { submitClicked } = this.state;

    let processedValue;
    if (value && value.value !== undefined) {
      processedValue = value.value;
    } else if (value && value.target) {
      processedValue = value.target.value;
    } else {
      processedValue = value;
    }

    // Handle amount field specially - store as string but validate as number
    if (fieldName === 'amount' && processedValue !== '') {
      // Replace comma with dot for consistent decimal formatting
      if (typeof processedValue === 'string') {
        processedValue = processedValue.replace(',', '.');
        // Only keep valid number characters and one decimal point
        processedValue = processedValue.replace(/[^0-9.]/g, '');
        // Remove extra decimal points (keep only the first one)
        const parts = processedValue.split('.');
        if (parts.length > 2) {
          processedValue = parts[0] + '.' + parts.slice(1).join('');
        }
      }
    }

    payoutForm = Object.assign(payoutForm, {
      [fieldName]: processedValue
    });


    if (submitClicked) {
      payoutForm.isFormValid();
    }

    this.setState({
      payoutForm: payoutForm
    });

    if (fieldName === 'mid' && processedValue) {
      const selectedMid = this.state.mids.find(mid => mid.value === processedValue || mid.id === processedValue);
      if (selectedMid && selectedMid.currency) {
        payoutForm.currency = selectedMid.currency;
        payoutForm.payoutCurrency = selectedMid.currency;

      this.setState({ 
        payoutForm: payoutForm,
        // Reset currencies array since we're updating with new MID data
        currencies: [{value: selectedMid.currency, label: selectedMid.currency}],
        // Reset balance and fields since currency changed
        showBalance: false,
        availableBalance: null,
        dynamicFields: [],
        useDefaultFields: true
      });        
      }
    }

    // Check if both MID and currency are selected to show balance and load params
    // Trigger when MID, currency, or payoutCurrency changes
    if ((fieldName === 'mid' || fieldName === 'currency' || fieldName === 'payoutCurrency') && payoutForm.mid && (payoutForm.currency || payoutForm.payoutCurrency)) {
      // Use payoutCurrency if available, otherwise fall back to currency
      const currencyToUse = payoutForm.payoutCurrency || payoutForm.currency;
      this.loadAvailableBalance(payoutForm.mid, currencyToUse);
      this.loadPayoutParams(payoutForm.mid, currencyToUse);
    } else if (fieldName === 'mid' || fieldName === 'currency' || fieldName === 'payoutCurrency') {
      this.setState({
        showBalance: false,
        availableBalance: null,
        dynamicFields: [],
        useDefaultFields: true
      });
    }

    // Auto-populate payout currency when currency is selected
    if (fieldName === 'currency') {
      payoutForm.payoutCurrency = payoutForm.currency;
      this.setState({ payoutForm: payoutForm });
    }

    // Sync currency selection when payout currency is changed
    if (fieldName === 'payoutCurrency') {
      payoutForm.currency = payoutForm.payoutCurrency;
      this.setState({ payoutForm: payoutForm });
    }
  };

  loadAvailableBalance = (mid, currency) => {
    this.setState({ isLoadingBalance: true });

    crudActions.get(`v1/payout/balance?mid=${mid}&currency=${currency}`).then(
      (response) => {
        if (response && response.balance !== undefined) {
          // Ensure consistent decimal formatting with "."
          let formattedBalance = response.balance;
          if (typeof formattedBalance === 'string') {
            formattedBalance = formattedBalance.replace(',', '.');
          }
          formattedBalance = Number(formattedBalance).toFixed(2);
          this.setState({
            availableBalance: formattedBalance,
            showBalance: true,
            isLoadingBalance: false
          });
        }
      }
    ).catch((err) => {
      // Mock balance for development when API is not available
      const mockBalance = (Math.random() * 10000 + 1000).toFixed(2);
      this.setState({
        availableBalance: mockBalance,
        showBalance: true,
        isLoadingBalance: false
      });
    });
  };

  loadPayoutParams = (mid, currency) => {
    this.setState({ isLoadingParams: true });

    crudActions.post(`v1/payout/params`, { mid, currency }).then(
      (response) => {
        if (response && response.fields && Array.isArray(response.fields)) {
          this.setState({
            dynamicFields: response.fields,
            useDefaultFields: false,
            isLoadingParams: false
          }, () => {
            this.updateFormWithDynamicFields();
          });
        } else {
          // Invalid response format, use fallback
          this.useFallbackFields();
        }
      }
    ).catch((err) => {
      // API not available, use fallback fields
      this.useFallbackFields();
    });
  };

  getFallbackFields = () => {
    return [
      {
        name: 'accountNumber',
        label: 'Account Number',
        type: 'text',
        required: true,
        validation: { type: 'isString', rules: { required: true } }
      },
      {
        name: 'bankName',
        label: 'Bank Name',
        type: 'text',
        required: true,
        validation: { type: 'isString', rules: { required: true } }
      },
      {
        name: 'bankBranch',
        label: 'Bank Branch',
        type: 'text',
        required: true,
        validation: { type: 'isString', rules: { required: true } }
      }     
    ];
  };

  useFallbackFields = () => {
    const fallbackFields = this.getFallbackFields();
    this.setState({
      dynamicFields: fallbackFields,
      useDefaultFields: true,
      isLoadingParams: false
    }, () => {
      this.updateFormWithDynamicFields();
    });
  };

  updateFormWithDynamicFields = () => {
    const { dynamicFields, payoutForm } = this.state;

    // Create base form data with fixed fields
    const baseFormData = {
      mid: payoutForm.mid || "",
      currency: payoutForm.currency || "",
      orderId: payoutForm.orderId || this.generateUUID(),
      country: payoutForm.country || "",
      account: payoutForm.account || "",
      ipaddress: payoutForm.ipaddress || "",
      email: payoutForm.email || "",
      amount: payoutForm.amount || "",
      payoutCurrency: payoutForm.payoutCurrency || "",
      callbackUrl: payoutForm.callbackUrl || "",
      returnUrl: payoutForm.returnUrl || ""
    };

    // Add dynamic fields to form data
    dynamicFields.forEach(field => {
      baseFormData[field.name] = payoutForm[field.name] || "";
    });

    // Create base validation rules for fixed fields
    const baseValidationRules = [
      //{ name: "mid", type: "isString", rules: { required: true } },
      { name: "currency", type: "isString", rules: { required: true } },
      { name: "orderId", type: "isString", rules: { required: true } },
      { name: "country", type: "isString", rules: { required: true } },
      { name: "account", type: "isString", rules: { required: true } },
      { name: "ipaddress", type: "isPattern", rules: { required: true, pattern: "^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^::1$|^::$|^(?:[0-9a-fA-F]{1,4}:){1,7}:$|^:(?::[0-9a-fA-F]{1,4}){1,7}$|^(?:[0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}$|^(?:[0-9a-fA-F]{1,4}:){1,5}(?::[0-9a-fA-F]{1,4}){1,2}$|^(?:[0-9a-fA-F]{1,4}:){1,4}(?::[0-9a-fA-F]{1,4}){1,3}$|^(?:[0-9a-fA-F]{1,4}:){1,3}(?::[0-9a-fA-F]{1,4}){1,4}$|^(?:[0-9a-fA-F]{1,4}:){1,2}(?::[0-9a-fA-F]{1,4}){1,5}$|^[0-9a-fA-F]{1,4}:(?::[0-9a-fA-F]{1,4}){1,6}$", customErrorMessage: "Please enter a valid IPv4 or IPv6 address" } },
      { name: "email", type: "isEmail", rules: { required: true } },
      { name: "amount", type: "isPattern", rules: { required: true, pattern: "^[0-9]+(\.[0-9]{1,2})?$", customErrorMessage: "Please enter a valid amount (e.g. 10.50)" } },
      { name: "payoutCurrency", type: "isString", rules: { required: true } },
      { name: "callbackUrl", type: "isUrl", rules: { required: true } },
      { name: "returnUrl", type: "isUrl", rules: { required: true } }
    ];

    // Add validation rules for dynamic fields
    dynamicFields.forEach(field => {
      if (field.validation) {
        baseValidationRules.push({
          name: field.name,
          type: field.validation.type || "isString",
          rules: field.validation.rules || { required: field.required || false }
        });
      }
    });

    // Create new form instance with updated data and validation
    const updatedForm = new Form(baseFormData, baseValidationRules);

    this.setState({ payoutForm: updatedForm });
  };

  onGenerateNewOrderId = () => {
    const newOrderId = this.generateUUID();
    this.onValueChange(newOrderId, 'orderId');
  };

  onSetMaxAmount = () => {
    const { availableBalance, payoutForm } = this.state;
    if (availableBalance) {
      // Force proper decimal formatting with dot separator
      let cleanBalance = String(availableBalance).replace(',', '.');
      let numberBalance = parseFloat(cleanBalance);
      let formattedBalance = numberBalance.toFixed(2);

      // Store as formatted string
      const updatedForm = Object.assign(payoutForm, {
        amount: formattedBalance
      });

      this.setState({ payoutForm: updatedForm });
    }
  };

  validateAmountAgainstBalance = (amount) => {
    const { availableBalance } = this.state;
    if (availableBalance) {
      const amountNum = parseFloat(String(amount).replace(',', '.'));
      const balanceNum = parseFloat(String(availableBalance).replace(',', '.'));
      if (amountNum > balanceNum) {
        return false;
      }
    }
    return true;
  };

  onSubmitPayout = () => {
    const { payoutForm, dynamicFields } = this.state;
    const isFormValid = payoutForm.isFormValid();
    const isAmountValid = this.validateAmountAgainstBalance(payoutForm.amount);

    this.setState({
      payoutForm: payoutForm,
      submitClicked: true
    });

    if (isFormValid && isAmountValid) {
      this.setState({ isLoading: true });

      // Get base form data (fixed fields)
      const baseData = payoutForm.data();

      // Collect all dynamic field values into a "dynamic" object
      const dynamicData = {};
      dynamicFields.forEach(field => {
        if (payoutForm[field.name] !== undefined) {
          dynamicData[field.name] = payoutForm[field.name];
        }
      });

      // Create final payload with dynamic fields in "dynamic" object
      const payloadData = {
        ...baseData,
        dynamic: dynamicData
      };

      crudActions.post(`v1/payout/request`, payloadData).then(
        (response) => {
          if (response) {
            this.setState({
              showSuccess: true,
              successMessage: "Payout request submitted successfully.",
              isLoading: false
            });
          }
        }
      ).catch(
        (err) => {
          if (err && err.message) {
            this.setState({
              showError: true,
              errorMessage: err.message,
              isLoading: false
            });
          }
        }
      );
    } else if (!isAmountValid) {
      this.setState({
        showError: true,
        errorMessage: "Amount cannot exceed available balance."
      });
    } else {
      this.setState({
        showError: true,
        errorMessage: "Please fill in all required fields correctly."
      });
    }
  };

  onConfirm = () => {
    this.setState({
      showSuccess: false,
      showError: false,
      errorMessage: "",
      successMessage: ""
    });
  };

  renderDynamicField = (field, index) => {
    const { payoutForm } = this.state;
    const fieldValue = payoutForm[field.name] || '';
    const hasError = payoutForm.errors && payoutForm.errors.has(field.name);
    const errorMessage = hasError ? payoutForm.errors.get(field.name) : '';

    switch (field.type) {
      case 'select':
        return (
          <Column key={index} flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>{field.label} {field.required && <span style={{color: 'red'}}>*</span>}</label>
            <Select
              className={hasError ? 'error-field' : ""}
              value={fieldValue}
              required={field.required}
              clearable={false}
              options={field.options || []}
              onChange={(value) => this.onValueChange(value, field.name)}
            />
            {hasError && <p className="error-message" style={{color: 'red', fontSize: '12px'}}>{errorMessage}</p>}
          </Column>
        );
      case 'number':
        return (
          <Column key={index} flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>{field.label} {field.required && <span style={{color: 'red'}}>*</span>}</label>
            <input
              type="number"
              step={field.step || "0.01"}
              min={field.min || "0"}
              className={"form-control " + (hasError ? 'error-field' : '')}
              value={fieldValue}
              onChange={(e) => this.onValueChange(e, field.name)}
              placeholder={field.placeholder || ''}
            />
            {hasError && <p className="error-message" style={{color: 'red', fontSize: '12px'}}>{errorMessage}</p>}
          </Column>
        );
      case 'email':
        return (
          <Column key={index} flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>{field.label} {field.required && <span style={{color: 'red'}}>*</span>}</label>
            <input
              type="email"
              className={"form-control " + (hasError ? 'error-field' : '')}
              value={fieldValue}
              onChange={(e) => this.onValueChange(e, field.name)}
              placeholder={field.placeholder || ''}
            />
            {hasError && <p className="error-message" style={{color: 'red', fontSize: '12px'}}>{errorMessage}</p>}
          </Column>
        );
      default: // text
        return (
          <Column key={index} flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>{field.label} {field.required && <span style={{color: 'red'}}>*</span>}</label>
            <input
              type="text"
              className={"form-control " + (hasError ? 'error-field' : '')}
              value={fieldValue}
              onChange={(e) => this.onValueChange(e, field.name)}
              placeholder={field.placeholder || ''}
            />
            {hasError && <p className="error-message" style={{color: 'red', fontSize: '12px'}}>{errorMessage}</p>}
          </Column>
        );
    }
  };

  renderAmountCurrencyAndDynamicFields = () => {
    const { dynamicFields, payoutForm, availableBalance, currencies, isLoadingParams } = this.state;

    const rows = [];

    if (isLoadingParams) {
      // Show Amount, Currency, and loading indicator
      rows.push(
        <Row key="amount-currency-loading" flexGrow={1} wrap={true} horizontal='start' vertical='end'>
          <Column flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>Amount <span style={{color: 'red'}}>*</span></label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                inputMode="decimal"
                pattern="[0-9]+([.][0-9]+)?"
                className={"form-control " + (
                  (payoutForm.errors && payoutForm.errors.has('amount')) ||
                  (payoutForm.amount && !this.validateAmountAgainstBalance(payoutForm.amount))
                  ? 'error-field' : '')}
                value={payoutForm.amount || ''}
                onChange={(e) => this.onValueChange(e, "amount")}
                style={{ paddingRight: availableBalance ? '100px' : '10px' }}
                placeholder="0.00"
              />
              {availableBalance && (
                <Button
                  className="btn btn-sm"
                  style={{
                    position: 'absolute',
                    right: '5px',
                    top: '2px',
                    height: '30px',
                    fontSize: '11px',
                    padding: '0 8px'
                  }}
                  onClick={this.onSetMaxAmount}
                >
                  Max available
                </Button>
              )}
            </div>
            {payoutForm.errors && payoutForm.errors.has('amount') && <p className="error-message" style={{color: 'red', fontSize: '12px'}}> {payoutForm.errors.get('amount')} </p>}
            {payoutForm.amount && !this.validateAmountAgainstBalance(payoutForm.amount) && (
              <p className="error-message" style={{color: 'red', fontSize: '12px'}}>
                Amount cannot exceed available balance ({Number(availableBalance).toFixed(2)} {payoutForm.currency})
              </p>
            )}
          </Column>
          <Column flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>Currency <span style={{color: 'red'}}>*</span></label>
            <Select
              className={payoutForm.errors && payoutForm.errors.has('payoutCurrency') ? 'error-field' : ""}
              value={payoutForm.payoutCurrency}
              required={true}
              clearable={false}
              options={currencies}
              onChange={(value) => this.onValueChange(value, 'payoutCurrency')}
            />
            {payoutForm.errors && payoutForm.errors.has('payoutCurrency') && <p className="error-message" style={{color: 'red', fontSize: '12px'}}> {payoutForm.errors.get('payoutCurrency')} </p>}
          </Column>
          <Column flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>Callback URL <span style={{color: 'red'}}>*</span></label>
            <input
              type="url"
              className={"form-control " + (payoutForm.errors && payoutForm.errors.has('callbackUrl') ? 'error-field' : '')}
              value={payoutForm.callbackUrl || ''}
              onChange={(e) => this.onValueChange(e, "callbackUrl")}
              placeholder="https://example.com/callback"
            />
            {payoutForm.errors && payoutForm.errors.has('callbackUrl') && <p className="error-message" style={{color: 'red', fontSize: '12px'}}> {payoutForm.errors.get('callbackUrl')} </p>}
          </Column>
          <Column flexGrow={1} vertical='center' alignSelf='center' style={{ textAlign: 'center' }}>
            <Spinner smallContainer={true} />
            <p style={{ marginTop: '10px', fontSize: '12px' }}>Loading payout fields...</p>
          </Column>
        </Row>
      );
    } else {
      // Show Amount, Currency, Callback URL, Return URL, and dynamic fields
      const firstRowDynamicFields = (dynamicFields && dynamicFields.length > 0) ? dynamicFields.slice(0, 0) : []; // No dynamic fields in first row now
      const remainingFields = (dynamicFields && dynamicFields.length > 0) ? dynamicFields.slice(0) : [];

      // First row: Amount, Currency, Callback URL, Return URL (4 fields)
      rows.push(
        <Row key="amount-currency-urls" flexGrow={1} wrap={true} horizontal='start' vertical='end'>
          <Column flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>Amount <span style={{color: 'red'}}>*</span></label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                inputMode="decimal"
                pattern="[0-9]+([.][0-9]+)?"
                className={"form-control " + (
                  (payoutForm.errors && payoutForm.errors.has('amount')) ||
                  (payoutForm.amount && !this.validateAmountAgainstBalance(payoutForm.amount))
                  ? 'error-field' : '')}
                value={payoutForm.amount || ''}
                onChange={(e) => this.onValueChange(e, "amount")}
                style={{ paddingRight: availableBalance ? '100px' : '10px' }}
                placeholder="0.00"
              />
              {availableBalance && (
                <Button
                  className="btn btn-sm"
                  style={{
                    position: 'absolute',
                    right: '5px',
                    top: '2px',
                    height: '30px',
                    fontSize: '11px',
                    padding: '0 8px'
                  }}
                  onClick={this.onSetMaxAmount}
                >
                  Max available
                </Button>
              )}
            </div>
            {payoutForm.errors && payoutForm.errors.has('amount') && <p className="error-message" style={{color: 'red', fontSize: '12px'}}> {payoutForm.errors.get('amount')} </p>}
            {payoutForm.amount && !this.validateAmountAgainstBalance(payoutForm.amount) && (
              <p className="error-message" style={{color: 'red', fontSize: '12px'}}>
                Amount cannot exceed available balance ({Number(availableBalance).toFixed(2)} {payoutForm.currency})
              </p>
            )}
          </Column>
          <Column flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>Currency <span style={{color: 'red'}}>*</span></label>
            <Select
              className={payoutForm.errors && payoutForm.errors.has('payoutCurrency') ? 'error-field' : ""}
              value={payoutForm.payoutCurrency}
              required={true}
              clearable={false}
              options={currencies}
              onChange={(value) => this.onValueChange(value, 'payoutCurrency')}
            />
            {payoutForm.errors && payoutForm.errors.has('payoutCurrency') && <p className="error-message" style={{color: 'red', fontSize: '12px'}}> {payoutForm.errors.get('payoutCurrency')} </p>}
          </Column>
          <Column flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>Callback URL <span style={{color: 'red'}}>*</span></label>
            <input
              type="url"
              className={"form-control " + (payoutForm.errors && payoutForm.errors.has('callbackUrl') ? 'error-field' : '')}
              value={payoutForm.callbackUrl || ''}
              onChange={(e) => this.onValueChange(e, "callbackUrl")}
              placeholder="https://example.com/callback"
            />
            {payoutForm.errors && payoutForm.errors.has('callbackUrl') && <p className="error-message" style={{color: 'red', fontSize: '12px'}}> {payoutForm.errors.get('callbackUrl')} </p>}
          </Column>
          <Column flexGrow={1} vertical='start' alignSelf='start' className="input-column">
            <label>Return URL <span style={{color: 'red'}}>*</span></label>
            <input
              type="url"
              className={"form-control " + (payoutForm.errors && payoutForm.errors.has('returnUrl') ? 'error-field' : '')}
              value={payoutForm.returnUrl || ''}
              onChange={(e) => this.onValueChange(e, "returnUrl")}
              placeholder="https://example.com/return"
            />
            {payoutForm.errors && payoutForm.errors.has('returnUrl') && <p className="error-message" style={{color: 'red', fontSize: '12px'}}> {payoutForm.errors.get('returnUrl')} </p>}
          </Column>
        </Row>
      );

      // Remaining rows: group remaining fields into rows of 4
      for (let i = 0; i < remainingFields.length; i += 4) {
        const rowFields = remainingFields.slice(i, i + 4);
        rows.push(
          <Row key={`dynamic-row-${i}`} flexGrow={1} wrap={true} horizontal='start' vertical='end'>
            {rowFields.map((field, fieldIndex) => this.renderDynamicField(field, `${i}-${fieldIndex}`))}
            {/* Fill remaining columns with empty spans */}
            {Array.from({ length: 4 - rowFields.length }, (_, emptyIndex) => (
              <Column key={`empty-${i}-${emptyIndex}`} flexGrow={1} vertical='start' alignSelf='start' className="input-column">
                <span/>
              </Column>
            ))}
          </Row>
        );
      }
    }

    return rows;
  };

  render() {
    const {
      payoutForm,
      mids,
      currencies,
      countries,
      availableBalance,
      showBalance,
      dynamicFields,
      isLoadingParams,
      isLoading,
      isLoadingBalance,
      showSuccess,
      showError,
      errorMessage,
      successMessage
    } = this.state;

    return (
      <Row flexGrow={ 1 } className="t365 module generateReports requestPayout" vertical='start'>
        <Column flexGrow={ 1 }>
          <ComponentHeader
            title="Request Payout"
            img={ PayoutIcon }
          />
          <Row flexGrow={ 1 } horizontal='start' wrap={ true } vertical='start'>
            <Column flexGrow={ 1 } vertical='start' className="panel-block">
              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    MID & CURRENCY SELECTION
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <div className="panel-content" style={ {overflow: 'unset'} }>
                    <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label>MID <span style={ {color: 'red'} }>*</span></label>
                        <Select
                          className={ payoutForm.errors.has('mid') ? 'error-field' : "" }
                          value={ payoutForm.mid }
                          required={ true }
                          clearable={ false }
                          options={ mids }
                          onChange={ (value) => this.onValueChange(value, 'mid') }
                        />
                        { payoutForm.errors.has('mid') && <p className="error-message" style={ {color: 'red', fontSize: '12px'} }> { payoutForm.errors.get('mid') } </p> }
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label>Currency <span style={ {color: 'red'} }>*</span></label>
                        <Select
                          className={ payoutForm.errors.has('currency') ? 'error-field' : "" }
                          value={ payoutForm.currency }
                          required={ true }
                          clearable={ false }
                          options={ currencies }
                          onChange={ (value) => this.onValueChange(value, 'currency') }
                        />
                        { payoutForm.errors.has('currency') && <p className="error-message" style={ {color: 'red', fontSize: '12px'} }> { payoutForm.errors.get('currency') } </p> }
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        { showBalance ? (
                          <div>
                            <label>Available Balance</label>
                            { isLoadingBalance ? (
                              <div style={ { display: "flex", alignItems: "center", justifyContent: "center", height: "35px" } }>
                                <Spinner smallContainer={ true } />
                              </div>
                            ) : (
                              <input
                                className="form-control"
                                value={ `${Number(availableBalance).toFixed(2)} ${payoutForm.currency}` }
                                disabled
                                style={ { backgroundColor: '#f9f9f9', fontWeight: 'bold' } }
                              />
                            )}
                          </div>
                        ) : (
                          <div style={ { height: '50px' } }></div>
                        )}
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <span/>
                      </Column>
                    </Row>
                  </div>
                </Panel.Body>
              </Panel>

              <Panel>
                <Panel.Heading>
                  <Panel.Title>
                    PAYOUT DETAILS
                  </Panel.Title>
                </Panel.Heading>
                <Panel.Body>
                  <div className="panel-content" style={ {overflow: 'unset'} }>
                    {/* Fixed Fields Row 1 */}
                    <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label>Order ID <span style={ {color: 'red'} }>*</span></label>
                        <div style={ { position: 'relative' } }>
                          <input
                            className={ "form-control " + (payoutForm.errors && payoutForm.errors.has('orderId') ? 'error-field' : '') }
                            value={ payoutForm.orderId || '' }
                            onChange={ (e) => this.onValueChange(e, "orderId") }
                            style={ { paddingRight: '80px' } }
                          />
                          <Button
                            className="btn btn-sm"
                            style={ {
                              position: 'absolute',
                              right: '5px',
                              top: '2px',
                              height: '30px',
                              fontSize: '11px',
                              padding: '0 8px'
                            } }
                            onClick={ this.onGenerateNewOrderId }
                          >
                            Generate
                          </Button>
                        </div>
                        { payoutForm.errors && payoutForm.errors.has('orderId') && <p className="error-message" style={ {color: 'red', fontSize: '12px'} }> { payoutForm.errors.get('orderId') } </p> }
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label>Country <span style={ {color: 'red'} }>*</span></label>
                        <Select
                          className={ payoutForm.errors.has('country') ? 'error-field' : "" }
                          value={ payoutForm.country }
                          required={ true }
                          clearable={ false }
                          options={ countries }
                          onChange={ (value) => this.onValueChange(value, 'country') }
                        />
                        { payoutForm.errors.has('country') && <p className="error-message" style={ {color: 'red', fontSize: '12px'} }> { payoutForm.errors.get('country') } </p> }
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label>Account <span style={ {color: 'red'} }>*</span></label>
                        <input
                          className={ "form-control " + (payoutForm.errors && payoutForm.errors.has('account') ? 'error-field' : '') }
                          value={ payoutForm.account || '' }
                          onChange={ (e) => this.onValueChange(e, "account") }
                        />
                        { payoutForm.errors && payoutForm.errors.has('account') && <p className="error-message" style={ {color: 'red', fontSize: '12px'} }> { payoutForm.errors.get('account') } </p> }
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label>IP Address <span style={ {color: 'red'} }>*</span></label>
                        <input
                          className={ "form-control " + (payoutForm.errors && payoutForm.errors.has('ipaddress') ? 'error-field' : '') }
                          value={ payoutForm.ipaddress || '' }
                          onChange={ (e) => this.onValueChange(e, "ipaddress") }
                          placeholder="192.168.1.1 or 2001:db8::1"
                        />
                        { payoutForm.errors && payoutForm.errors.has('ipaddress') && <p className="error-message" style={ {color: 'red', fontSize: '12px'} }> { payoutForm.errors.get('ipaddress') } </p> }
                      </Column>
                    </Row>
                    <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <label>Email <span style={ {color: 'red'} }>*</span></label>
                        <input
                          type="email"
                          className={ "form-control " + (payoutForm.errors && payoutForm.errors.has('email') ? 'error-field' : '') }
                          value={ payoutForm.email || '' }
                          onChange={ (e) => this.onValueChange(e, "email") }
                        />
                        { payoutForm.errors && payoutForm.errors.has('email') && <p className="error-message" style={ {color: 'red', fontSize: '12px'} }> { payoutForm.errors.get('email') } </p> }
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <span/>
                      </Column>
                    </Row>
                    {/* Fixed Fields Row 2 with Dynamic Fields */}
                    { this.renderAmountCurrencyAndDynamicFields() }

                    {/* Submit Button Row */}
                    <Row flexGrow={ 1 } wrap={ true } horizontal='start' vertical='end'>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='start' alignSelf='start' className="input-column">
                        <span/>
                      </Column>
                      <Column flexGrow={ 1 } vertical='end' alignSelf='end' className="input-column">
                        <Button
                          type="submit"
                          className="btn defaultBtn"
                          style={ { outline: isLoading ? "5px auto -webkit-focus-ring-color" : "" } }
                          onClick={ this.onSubmitPayout }
                          disabled={ isLoading }
                        >
                          { isLoading ? "SUBMITTING..." : "SUBMIT PAYOUT" }
                        </Button>
                      </Column>
                    </Row>
                  </div>
                </Panel.Body>
              </Panel>
            </Column>
          </Row>
        </Column>
        <SweetAlert
          show={ showSuccess }
          title="Success"
          type="success"
          confirmButtonColor="#25282a"
          text={ successMessage }
          onConfirm={ this.onConfirm }
        />
        <SweetAlert
          show={ showError }
          title="Error"
          type="error"
          confirmButtonColor="#DD6B55"
          text={ errorMessage }
          onConfirm={ this.onConfirm }
        />
      </Row>
    );
  }
}

export default RequestPayout;